import { Component } from '@angular/core';
import { MercadoPagoService } from '@shared/services/mercado-pago.service';

@Component({
    selector: 'app-root',
    template: `<router-outlet></router-outlet>`
})
export class RootComponent {

    constructor(private _mercadoPagoService: MercadoPagoService) {
        this._mercadoPagoService.iniciarServico();
    }
}
